import React, { Component } from "react";
import { Form, Col } from "react-bootstrap";

class Sorting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: "",
      sortBy: "",
      pageSize: "",
    };
  }

  onSortingChange = (name, value) => {
    this.setState({
      [name]: value,
    });
    var object = {
      target: {
        name: name,
        value: value,
      },
    };
    this.props.onSortingChange(object);
  };

  render() {
    const pageSizeOptions = [
      { name: "10", value: 10 },
      { name: "25", value: 25 },
      { name: "50", value: 50 },
      { name: "100", value: 100 },
    ];

    const pageSize = pageSizeOptions.map((pageSize) => (
      <option key={pageSize.value} value={pageSize.value}>
        {pageSize.name}
      </option>
    ));

    const sortByOptions = [
      { name: "ID Number", value: "epa_id" },
      { name: "Facility", value: "fac_name" },
    ];

    const orderByOptions = [
      { name: "A-Z", value: "ASC" },
      { name: "Z-A", value: "DESC" },
    ];

    if (
      this.props.results.keyword &&
      this.props.results.keyword != "" &&
      this.props.results.total_records == 0
    ) {
      return <div className="search-noresults">No results found.</div>;
    }

    if (
      this.props.results.keyword &&
      this.props.results.keyword != "" &&
      this.props.results.total_records == 0
    ) {
      return <div className="search-noresults">No results found.</div>;
    } else if (this.props.results.total_records == 0) {
      return <div></div>;
    } else if (!this.props.results) {
      return <div></div>;
    }

    return (
      <div>
        <div className="group m-b-10">
          <div className=""></div>
          <div className="search-results-sort" style={{ textAlign: "right" }}>
            <Form.Group as={Col} controlId="sorting-filters">
              <div className="form-inline float-sm-left m-b-sm p-t-sm">
                {this.props.isFetching ? (
                  <p
                    className="animated-background"
                    style={{ height: "22px", width: "180px" }}
                  ></p>
                ) : (
                  <div>
                    <span className="m-r-sm m-b-sm" style={{ fontSize: "1em" }}>
                      {this.props.results.total_records} Result
                      {this.props.results.total_records > 1 ? "s" : ""}
                    </span>
                  </div>
                )}
              </div>
              <div className="form-inline float-sm-right m-b-sm">
                <div className="m-r-sm">
                  <Form.Control
                    name={"sort"}
                    placeholder="Sort"
                    value={this.state.sort}
                    onChange={(e) =>
                      this.onSortingChange(e.target.name, e.target.value)
                    }
                    as="select"
                    size="sm"
                    custom
                  >
                    <option value="" disabled>
                      Sort...
                    </option>
                    {sortByOptions.map((d, i) => (
                      <option key={d.value} value={d.value}>
                        {d.name}
                      </option>
                    ))}
                  </Form.Control>
                </div>
                <div className="m-r-sm">
                  <Form.Control
                    name={"sortBy"}
                    placeholder="Order"
                    value={this.state.sortBy}
                    onChange={(e) =>
                      this.onSortingChange(e.target.name, e.target.value)
                    }
                    as="select"
                    size="sm"
                    custom
                  >
                    <option value="" disabled>
                      Order...
                    </option>
                    {orderByOptions.map((d, i) => (
                      <option key={d.value} value={d.value}>
                        {d.name}
                      </option>
                    ))}
                  </Form.Control>
                </div>
                <div>
                  <Form.Control
                    name={"pageSize"}
                    placeholder="Show"
                    value={this.state.pageSize}
                    onChange={(e) =>
                      this.onSortingChange(e.target.name, e.target.value)
                    }
                    as="select"
                    size="sm"
                    custom
                  >
                    <option value="" disabled>
                      Show...
                    </option>
                    {pageSizeOptions.map((d, i) => (
                      <option key={d.value} value={d.value}>
                        {d.name}
                      </option>
                    ))}
                  </Form.Control>
                </div>
              </div>
            </Form.Group>
          </div>
        </div>
      </div>
    );
  }
}

export default Sorting;
